import "./Footer.css";
import { motion } from "framer-motion";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaEnvelope,
  FaArrowRight
} from "react-icons/fa";

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 60
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9
    }
  }
};

export default function Footer() {
  return (
    <footer className="footer">

      <div className="footer-glow glow-1"></div>
      <div className="footer-glow glow-2"></div>

      <div className="container">

        {/* TOP SECTION */}

        <motion.div
          className="footer-top"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >

          <motion.div variants={fadeUp}>
            <span className="footer-tag">
              GLOBAL TECHNOLOGY COMPANY
            </span>

            <h2 className="footer-heading">
              Building Intelligent Ecosystems Through
            </h2>
            <h2 className="footer-heading" style={{'color' : '#08469a'}}>
              AI, IoT & Digital Innovation.
            </h2>

            <p className="footer-description">
              Glintgan Technologies empowers
              businesses with Artificial Intelligence,
              Cloud Platforms, Enterprise Applications,
              Smart Agriculture and Digital Transformation
              solutions across global markets.
            </p>

            <div className="socials">

              <a href="#">
                <FaFacebookF />
              </a>

              <a href="#">
                <FaInstagram />
              </a>

              <a href="#">
                <FaLinkedinIn />
              </a>

            </div>

          </motion.div>

        </motion.div>

        {/* CARDS */}

        <motion.div
          className="footer-grid"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >

          {/* CONTACT */}

          <motion.div
            className="footer-card"
            variants={fadeUp}
          >
            <h3>Contact Us</h3>

            <div className="info-item">
              <FaEnvelope />
              <a href="mailto:sales@g-g.co.in">
                sales@g-g.co.in
              </a>
            </div>

            <div className="info-item">
              <FaWhatsapp />
              <a
                href="https://wa.me/918688477777"
                target="_blank"
                rel="noreferrer"
              >
                +91 86884 77777
              </a>
            </div>
          </motion.div>

          {/* INDIA */}

          <motion.div
            className="footer-card"
            variants={fadeUp}
          >
            <h3>India Office</h3>

            <p>
              Glintgan Technologies Pvt Ltd
              <br />
              2nd Floor, 205,
              PSR Prime Towers Road,
              DLF Cyber City,
              Gachibowli,
              Hyderabad,
              Telangana 500032
            </p>
          </motion.div>

          {/* GLOBAL */}

          <motion.div
            className="footer-card"
            variants={fadeUp}
          >
            <h3>Malaysia Office</h3>

            <p>
              {/* <strong>Malaysia</strong> */}
              {/* <br /> */}
              Idealogic Technologies Sdn Bhd
              <br />
                C-05-13, Pusat Komersial Tebing Selatan
                No. 179, Jalan Klang Lama
                58000, Kuala Lumpur, Malaysia.

            </p>
          </motion.div>

          {/* LINKS */}

          <motion.div
            className="footer-card"
            variants={fadeUp}
          >
            <h3>Singapore Office</h3>
            <p>
              {/* <strong>Singapore</strong> */}
              {/* <br /> */}
              Idealogic Technologies Pte Ltd
              <br/>
                17 Punggol Field Walk, #06-06, Singapore 828 747.
            </p>
          </motion.div>

        </motion.div>

      </div>

      {/* COPYRIGHT */}

      <div className="footer-bottom">

        <div className="container">

          <p>
            © {new Date().getFullYear()}
            {" "}
            Gangs n Gangs Technosolutions Pvt Ltd.
            All Rights Reserved.
          </p>

        </div>

      </div>

    </footer>
  );
}